var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExamUniformBatchDateRange',_vm._g(_vm._b({attrs:{"date-key":"examQuery"}},'ExamUniformBatchDateRange',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }